import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Grid,
  CircularProgress
} from "@material-ui/core";
import { ShoppingCart, CloudUpload } from "@mui/icons-material";
import { i18n } from "../../translate/i18n";
import Compressor from "compressorjs";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

const FlowBuilderAddProductModal = ({ open, onSave, data, onUpdate, close }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "",
    imageUrl: "",
    url: "",
    productId: ""
  });
  
  const [loading, setLoading] = useState(false);
  const [medias, setMedias] = useState([]);
  const [preview, setPreview] = useState();

  useEffect(() => {
    if (data && open === "edit") {
      setFormData({
        title: data.data.title || "",
        description: data.data.description || "",
        price: data.data.price || "",
        imageUrl: data.data.imageUrl || "",
        url: data.data.url || "",
        productId: data.data.productId || ""
      });
      if (data.data.imageUrl && !data.data.imageUrl.startsWith("http")) {
        setPreview(process.env.REACT_APP_BACKEND_URL + '/public/company' + data.companyId + '/flow/' + data.data.imageUrl);
      } else if (data.data.imageUrl) {
        setPreview(data.data.imageUrl);
      }
    } else {
      setFormData({
        title: "",
        description: "",
        price: "",
        imageUrl: "",
        url: "",
        productId: ""
      });
      setPreview(null);
      setMedias([]);
    }
  }, [data, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChangeMedias = e => {
    if (!e.target.files) return;
    if (e.target.files[0].size > 2000000) {
      toast.error("Arquivo é muito grande! 2MB máximo");
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    if (preview && !preview.startsWith("http")) URL.revokeObjectURL(preview);
    setPreview(URL.createObjectURL(e.target.files[0]));
    setMedias(selectedMedias);
  };

  const handleSave = async () => {
    setLoading(true);
    let uploadedFilename = formData.imageUrl;

    if (medias.length > 0) {
      const formDataUpload = new FormData();
      formDataUpload.append("fromMe", true);

      try {
        const processMedia = (media) => {
          return new Promise((resolve, reject) => {
            new Compressor(media, {
              quality: 0.7,
              success(result) { resolve({ file: result, name: result.name }); },
              error(err) { reject(err); }
            });
          });
        };

        const processedMedia = await processMedia(medias[0]);
        formDataUpload.append("medias", processedMedia.file);
        formDataUpload.append("body", processedMedia.name);

        const res = await api.post("/flowbuilder/img", formDataUpload);
        uploadedFilename = res.data.name;
      } catch (err) {
        toastError(err);
        setLoading(false);
        return;
      }
    }

    const finalData = { ...formData, imageUrl: uploadedFilename };

    if (open === "edit") {
      onUpdate({ ...data, data: { ...data.data, ...finalData } });
    } else if (open === "create") {
      onSave(finalData);
    }
    close();
    setLoading(false);
  };

  return (
    <Dialog open={!!open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <ShoppingCart />
          <Typography variant="h6">
            {open === "edit" ? "Editar Produto" : "Adicionar Produto"}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Título do Produto" name="title" value={formData.title} onChange={handleChange} fullWidth variant="outlined" helperText="Ex: Tênis Nike Revolution" />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Descrição" name="description" value={formData.description} onChange={handleChange} fullWidth multiline rows={3} variant="outlined" helperText="Você pode usar variáveis como ${nome}" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="Preço (R$)" name="price" value={formData.price} onChange={handleChange} fullWidth type="number" variant="outlined" helperText="Use formato 149.90" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField label="ID do Produto (SKU)" name="productId" value={formData.productId} onChange={handleChange} fullWidth variant="outlined" helperText="Opcional. Deixe em branco para auto-gerar" />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="column" gap={2} alignItems="center">
              {preview && <img src={preview} alt="Preview" style={{ width: "100%", maxHeight: "200px", objectFit: "contain", borderRadius: "8px", border: "1px solid #ddd" }} />}
              {!loading && (
                <Button variant="contained" component="label" color="default" startIcon={<CloudUpload />}>
                  Fazer Upload da Imagem
                  <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    hidden
                    onChange={handleChangeMedias}
                  />
                </Button>
              )}
              {loading && <CircularProgress size={24} />}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TextField label="Link do Checkout/Loja" name="url" value={formData.url} onChange={handleChange} fullWidth variant="outlined" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>
          {loading ? "Salvando..." : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddProductModal;
